module.exports = __webpack_public_path__ + "static/img/kp.48796976.png";